import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'chassis-image',
    styleUrls: ['image.component.scss'],
    templateUrl: 'image.component.html'
})

export class ImageComponent implements OnInit {

    /**
     * Url to image
     */
    @Input() public image: string | boolean | null;

    /**
     * Show as thumbnail -> square block of 75x75
     */
    @Input() public thumbnail = false;

    /**
     * Respect the aspect ratio
     * if false -> show square block and cover it
     */
    @Input() public respectAspectRatio = true;

    /**
     * Width in pixels
     */
    @Input() public width: string;

    constructor() {
    }

    ngOnInit() {

        // make sure that a boolean is assigned when input value is empty string
        // in situations like this: <chassis-image thumbnail>
        this.thumbnail          = this.thumbnail === false ? false : true;
        this.respectAspectRatio = this.respectAspectRatio === false ? false : true;

        if (!this.image) {
            this.respectAspectRatio = false;
        }

        if (!this.width && this.thumbnail) {
            this.width = '75px';
        } else if (!this.width && !this.thumbnail) {
            this.width = '100%';
        }

    }

    public getHeight() {
        if (this.width && !this.respectAspectRatio) {
            if (this.width.substr(-2) === 'px') {
                return this.width;
            }
        }

        return null;
    }

    public getPaddingTop() {
        if (this.width && !this.respectAspectRatio) {
            if (this.width.substr(-1) === '%') {
                return this.width;
            }
        }

        return null;
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/files/components/image/image.component.ts